import React from 'react';
import {
  FormProps,
  Modal,
  ModalBody,
  ModalFooter,
  ModalProps,
} from 'react-bootstrap';
import Button from '../../../components/Button';
import ModalHeader from '../../../components/ModalHeader';

export type customDeleteModalProps = ModalProps &
  React.PropsWithChildren<{
    showModal: boolean;
    handleClose: () => void;
    handleSubmit: () => void;
    formProps?: FormProps;
    title: string;
  }>;

const DeleteModal = ({
  showModal = false,
  handleClose,
  handleSubmit,
  formProps,
  title,
  children,
  ...props
}: customDeleteModalProps) => {
  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="lg">
      <ModalHeader>
        <h4 className={'text-sm-20-lg-32'}>{title}</h4>
      </ModalHeader>
      <ModalBody className="pt-5">{children}</ModalBody>
      <ModalFooter>
        <Button
          className="mt-4 mt-lg-0"
          variant="primary-outline"
          onMouseDown={handleClose}
        >
          Cancel
        </Button>
        <Button
          className="mb-4 mt-lg-0"
          onMouseDown={handleSubmit}
        >
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteModal;
